import axios from 'axios'
import { store } from '../redux/store'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
})

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const state = store.getState()
    const token = state.auth.tokens?.jwt_token // Prefer jwt_token

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

export default instance
